/**
 * OverlapDisplay - Display component for a single overlap
 * 
 * This component shows a single meal scheduling conflict with options
 * for how to resolve it, including visual preview of the meals involved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import MealPreviewCard from '../../grid/MealPreviewCard.react';
import ResolutionOptions from './ResolutionOptions.react';

import './OverlapDisplay.scss';

const OverlapDisplay = ({
    overlap,
    action,
    onActionChange,
    mode = 'reschedule',
    availableActions = null
}) => {
    const { mealType, offset, destMeals, sourceMeals } = overlap;
    
    return (
        <div className="overlap-display">
            <div className="overlap-display__header">
                <h4 className="overlap-display__title">
                    {mealType}, Day {offset + 1}
                </h4>
            </div>
            
            <div className="overlap-display__content">
                <div className="overlap-display__meals-horizontal">
                    <div className="overlap-display__meal-card">
                        <div className="overlap-display__meal-label">PREVIOUSLY SCHEDULED</div>
                        <MealPreviewCard meals={destMeals} />
                    </div>

                    <div className="overlap-display__action-center">
                        <ResolutionOptions
                            value={action}
                            onChange={onActionChange}
                            mode={mode}
                            availableActions={availableActions}
                        />
                    </div>

                    <div className="overlap-display__meal-card">
                        <div className="overlap-display__meal-label">NEW</div>
                        <MealPreviewCard meals={sourceMeals} />
                    </div>
                </div>
            </div>
        </div>
    );
};

OverlapDisplay.propTypes = {
    overlap: PropTypes.shape({
        mealType: PropTypes.string.isRequired,
        offset: PropTypes.number.isRequired,
        destMeals: PropTypes.arrayOf(PropTypes.object).isRequired,
        sourceMeals: PropTypes.arrayOf(PropTypes.object).isRequired
    }).isRequired,
    action: PropTypes.string,
    onActionChange: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(['reschedule', 'repeat']),
    availableActions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
    }))
};

export default OverlapDisplay;